"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("./index178.js");var e=o.sharedStoreExports,s=function(r,t){return e[r]||(e[r]=t||{})};exports.shared=s;
